// /**
//  * Initialize global menu and nav elements
//  */

class GlobalMenus {
  constructor() {
    this.header = document.querySelector("header");
    this.footer = document.querySelector("footer");
    this.events();
  }

  events() {
    window.addEventListener("scroll", () => {
      if (window.pageYOffset > 50) {
        this.header.classList.add("scrolled");
      } else {
        this.header.classList.remove("scrolled");
      }
    });
  }
}

export default GlobalMenus;
